// extracted by mini-css-extract-plugin
export const header = "index-module--header--GkXlg";
export const welcome = "index-module--welcome--3xsUE";
export const welcomeLight = "index-module--welcomeLight--2_vr7";
export const coverImage = "index-module--coverImage--3xtSW";
export const cta = "index-module--cta--DDUzW";
export const aboutCta = "index-module--aboutCta--1QK6P";
export const sectionHeader = "index-module--sectionHeader--jcq6g";
export const blogFeaturedImage = "index-module--blogFeaturedImage--3gKe8";
export const readMoreCta = "index-module--readMoreCta--3Tn_l";